import { Dispatch, SetStateAction } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { BulkImportType } from '../../../../../types';
import { BulkOpsFormValues } from './create-bulk-op-dialog';

export function selectGuidedPath(
  setValue: UseFormSetValue<BulkOpsFormValues>,
  selectedBulkImportType: BulkImportType | null,
  setSpreadSheetName: Dispatch<SetStateAction<string>>
) {
  setValue('path', 'guideMe');
  if (
    selectedBulkImportType!.name === 'calendarPermissionSettings' ||
    selectedBulkImportType!.name === 'signatureTemplateBlackListStatus' ||
    selectedBulkImportType!.name === 'userImport' ||
    selectedBulkImportType!.name === 'groupMemberSettingsUpdate' ||
    selectedBulkImportType!.name === 'labelDriveDocs' ||
    selectedBulkImportType!.name === 'removeUsersShares' ||
    selectedBulkImportType!.name === 'removeSharesFromUser'
  ) {
    setValue('columns', selectedBulkImportType!.columns);
    setValue('sourceType', 'User');
    setValue('sources', null);
    setValue('spreadsheetId', null);
    setSpreadSheetName('');
  } else if (selectedBulkImportType!.name === 'sharedContactImport') {
    setValue('columns', selectedBulkImportType!.columns);
    setValue('spreadsheetId', null);
    setSpreadSheetName('');
  } else if (selectedBulkImportType!.name === 'groupImport') {
    setValue('columns', selectedBulkImportType!.columns);
    setValue('spreadsheetId', null);
    setSpreadSheetName('');
    setValue('sourceType', 'Group');
    setValue('sources', null);
  } else if (selectedBulkImportType!.name === 'gPanelRoleImport') {
    setValue('columns', selectedBulkImportType!.columns);
    setValue('spreadsheetId', null);
    setSpreadSheetName('');
    setValue('sourceType', 'gPanel_Role');
    setValue('sources', null);
  }
}

export function selectAdvancedPath(
  setValue: UseFormSetValue<BulkOpsFormValues>,
  selectedBulkImportType: BulkImportType | null,
  setSpreadSheetName: Dispatch<SetStateAction<string>>
) {
  setValue('path', 'advanced');
  if (
    selectedBulkImportType!.name === 'calendarPermissionSettings' ||
    selectedBulkImportType!.name === 'signatureTemplateBlackListStatus' ||
    selectedBulkImportType!.name === 'userImport' ||
    selectedBulkImportType!.name === 'gPanelRoleImport' ||
    selectedBulkImportType!.name === 'groupMemberSettingsUpdate' ||
    selectedBulkImportType!.name === 'labelDriveDocs' ||
    selectedBulkImportType!.name === 'removeUsersShares' ||
    selectedBulkImportType!.name === 'removeSharesFromUser'
  ) {
    setValue('sourceType', null);
    setValue('sources', null);
    setValue('columns', null);
    setValue('spreadsheetId', null);
    setSpreadSheetName('');
  } else if (selectedBulkImportType!.name === 'sharedContactImport') {
    setValue('columns', null);
    setValue('spreadsheetId', null);
    setSpreadSheetName('');
  } else if (selectedBulkImportType!.name === 'groupImport') {
    setValue('columns', null);
    setValue('sourceType', null);
    setValue('sources', null);
    setValue('spreadsheetId', null);
    setSpreadSheetName('');
  }
}
